import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=37d36e85&scoped=true&"
var script = {}
import style0 from "./calendar.vue?vue&type=style&index=0&id=37d36e85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d36e85",
  null
  
)

export default component.exports